import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { TokenCreatedSchema, TokenValidFormDataSchema } from '../schema';
import { TokenCreatedType, TokenValidFormDataType } from '../schema/types';
import { TokenUrl } from './TokenUrl';

const postToken = (token: TokenValidFormDataType) =>
  apiClient
    .post<TokenCreatedType>(
      expand(TokenUrl.TOKENS, {}),
      TokenValidFormDataSchema.parse(token),
    )
    .then((response) => TokenCreatedSchema.parse(response.data));

const deleteToken = (id: number) =>
  apiClient
    .delete<void>(expand(TokenUrl.TOKEN, { tokenId: id }))
    .then((response) => response.data);

export const useMutateToken = createApiMutationHook(
  ['token'],
  getMutationFn(postToken, undefined, deleteToken),
);
